var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map"},[_c('my-header',{attrs:{"title":"地图"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }